import React from 'react';
import { node, string, oneOf } from 'prop-types';
import { withErrorBoundary } from 'react-error-boundary';
import Alert from '@mui/material/Alert';
import { Colors, Column, H4, LabelText } from '../..';
import { ChartWrapper } from './ChartsWrapper.styles';
const _ChartsWrapper = _ref => {
  let {
    children,
    headLine,
    tagLine,
    chartBackgroundColor,
    chartPadding
  } = _ref;
  return /*#__PURE__*/React.createElement(Column, {
    style: {
      gap: '8px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H4, null, headLine), /*#__PURE__*/React.createElement(LabelText, {
    style: {
      color: Colors.new_grey
    }
  }, tagLine)), /*#__PURE__*/React.createElement(ChartWrapper, {
    className: "chart-wrapper-inner",
    padding: chartPadding,
    chartBackgroundColor: chartBackgroundColor
  }, children));
};
_ChartsWrapper.propTypes = {
  chartPadding: oneOf(['small', 'medium', 'large']),
  headLine: string.isRequired,
  tagLine: string.isRequired,
  children: node.isRequired,
  chartBackgroundColor: string
};
_ChartsWrapper.defaultProps = {
  chartBackgroundColor: 'purple',
  chartPadding: ''
};
export const ChartsWrapper = withErrorBoundary(_ChartsWrapper, {
  fallback: /*#__PURE__*/React.createElement(Alert, {
    severity: "error"
  }, "Error rendering chart. ")
});